/**
 * Fixed "Protected by OVHcloud Anti-DDoS" trust badge — shared across the
 * Uliunai network (identical to the KF1 badge) for a consistent signal.
 */
export default function OvhBadge() {
  return (
    <a
      href="https://www.ovhcloud.com/en/security/anti-ddos/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Protected by OVH Anti-DDoS"
      className="ovh-badge"
    >
      <span className="ovh-badge__ring" aria-hidden="true">
        <svg viewBox="0 0 100 100">
          <circle
            cx="50" cy="50" r="46"
            fill="none" stroke="#1B80E0" strokeWidth="0.8"
            strokeDasharray="1 4" opacity="0.7"
          />
          <circle cx="50" cy="4"  r="1.5" fill="#1B80E0" />
          <circle cx="50" cy="96" r="1.5" fill="#1B80E0" />
        </svg>
      </span>
      <span className="ovh-badge__hex">
        <span className="ovh-badge__o">OVH</span>
        <span className="ovh-badge__t">DDoS Shield</span>
      </span>
      <span className="ovh-badge__pulse" aria-hidden="true" />
      <span className="ovh-badge__tooltip" role="tooltip">Protected by OVHcloud Anti-DDoS</span>

      <style>{`
        .ovh-badge {
          position: fixed;
          left: 18px;
          bottom: 18px;
          z-index: 50;
          width: 84px;
          height: 96px;
          display: block;
          text-decoration: none;
          cursor: pointer;
          filter: drop-shadow(0 6px 18px rgba(27,128,224,0.28));
          transition: transform 220ms ease, filter 220ms ease;
        }
        .ovh-badge:hover {
          transform: translateY(-2px);
          filter: drop-shadow(0 10px 24px rgba(27,128,224,0.5));
        }
        .ovh-badge__hex {
          position: absolute;
          inset: 8px;
          background:
            radial-gradient(circle at 30% 25%, rgba(255,255,255,0.18), transparent 55%),
            linear-gradient(160deg, #1B80E0 0%, #0e3b75 70%, #061d3d 100%);
          clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #fff;
          text-align: center;
        }
        .ovh-badge__o {
          font-family: 'Nunito', system-ui, sans-serif;
          font-weight: 900;
          font-size: 19px;
          letter-spacing: 0.02em;
          line-height: 1;
        }
        .ovh-badge__t {
          font-family: 'JetBrains Mono', monospace;
          font-size: 7px;
          letter-spacing: 0.18em;
          margin-top: 4px;
          opacity: 0.9;
          text-transform: uppercase;
        }
        .ovh-badge__ring {
          position: absolute;
          inset: 0;
          animation: ovh-badge-spin 12s linear infinite;
          pointer-events: none;
        }
        .ovh-badge__ring svg { width: 100%; height: 100%; display: block; }
        .ovh-badge__pulse {
          position: absolute;
          top: 6px;
          right: 6px;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #4ade80;
          box-shadow: 0 0 0 0 rgba(74,222,128,0.6);
          animation: ovh-badge-pulse 1.8s infinite;
          pointer-events: none;
        }
        .ovh-badge__tooltip {
          position: absolute;
          left: 100%;
          bottom: 14px;
          margin-left: 10px;
          white-space: nowrap;
          padding: 6px 10px;
          background: rgba(8, 12, 18, 0.92);
          border: 1px solid rgba(27,128,224,0.4);
          color: #d4faff;
          font-family: 'JetBrains Mono', monospace;
          font-size: 10px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          opacity: 0;
          transform: translateX(-4px);
          transition: opacity 200ms ease, transform 200ms ease;
          pointer-events: none;
          backdrop-filter: blur(4px);
        }
        .ovh-badge:hover .ovh-badge__tooltip,
        .ovh-badge:focus-visible .ovh-badge__tooltip {
          opacity: 1;
          transform: translateX(0);
        }
        @keyframes ovh-badge-spin { to { transform: rotate(360deg); } }
        @keyframes ovh-badge-pulse {
          0%   { box-shadow: 0 0 0 0 rgba(74,222,128,0.7); }
          70%  { box-shadow: 0 0 0 9px rgba(74,222,128,0); }
          100% { box-shadow: 0 0 0 0 rgba(74,222,128,0); }
        }
        @media (max-width: 640px) {
          .ovh-badge { width: 64px; height: 74px; left: 10px; bottom: 10px; }
          .ovh-badge__o { font-size: 14px; }
          .ovh-badge__t { font-size: 6px; }
        }
        @media (prefers-reduced-motion: reduce) {
          .ovh-badge__ring,
          .ovh-badge__pulse { animation: none; }
        }
      `}</style>
    </a>
  )
}
